import { FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import React from "react";

interface PaymentMethodsProps {
  paylate: boolean;
  cashpay: boolean;
  paycard: boolean;
  setpaylate: React.Dispatch<React.SetStateAction<boolean>>;
  setcashpay: React.Dispatch<React.SetStateAction<boolean>>;
  setpaycard: React.Dispatch<React.SetStateAction<boolean>>;
}

const PaymentMethods: React.FC<PaymentMethodsProps> = ({ paylate, cashpay, paycard, setpaylate, setcashpay, setpaycard }) => {
  return (
    <div className="w-full">
      <FormControl className="w-full">
        <RadioGroup
          row
          value={
            paylate ? "paylate" :
              cashpay ? "cashpay" :
                paycard ? "paycard" :
                  ""
          }
          onChange={(e) => {
            const value = e.target.value;

            if (value === "paylate") {
              setpaylate(true);
              setcashpay(false);
              setpaycard(false);
            } else if (value === "cashpay") {
              setcashpay(true);
              setpaylate(false);
              setpaycard(false);
            } else if (value === "paycard") {
              setpaycard(true);
              setpaylate(false);
              setcashpay(false);
            }
          }}
          className="flex justify-between w-full" >
          <FormControlLabel value="paylate" control={<Radio size="small" />} label="Buy on credit" className="cursor-pointer" />

          <FormControlLabel value="paycard" control={<Radio size="small" />} label="Card" className="cursor-wait" />

          <FormControlLabel value="cashpay" control={<Radio size="small" />} label="Cash" onClick={() => { setcashpay(true); setpaylate(false); }} className="cursor-pointer" />
        </RadioGroup>
      </FormControl>
    </div>
  );
};

export default PaymentMethods;
